import SideBar from "./Component/sidebar/sidebar";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Login from "./Component/login/login";
import Users from "./pages/Users/Users";
import Header from "./Component/header/Header";
import Category from "./pages/Category/Category";
import { Toaster } from "react-hot-toast";
import MyProfile from "./pages/Setting/MyProfile";
import MultiBanner from "./pages/SiteBanner/MultiBanner";
import CategoryCreate from "./pages/Category/CategoryCreate";
import UserDetails from "./pages/Users/UserDetails";
import Dashboard from "./pages/Dashboard/Dashboard";
import Comment from "./pages/Comment/Comment";
import Seller from "./pages/Seller/Seller";
import SellerDetails from "./pages/Seller/SellerDetails";
import Orders from "./pages/Product/ordersProduct/orders";
import Invoice from "./pages/Invoice/Invoice";
import InvoiceDetails from "./pages/Invoice/InvoiceDetails";
import PaymentMethod from "./pages/PaymentMethod/PaymentMethod";
import MainBanner from "./pages/SiteBanner/MainBanner";
import EditBanners from "./pages/SiteBanner/EditBanners";
import FoodBanner from "./pages/SiteBanner/FoodBanner";
import MarketBanner from "./pages/SiteBanner/MarketBanner";
import AllBanners from "./pages/SiteBanner/AllBanners";
import Brands from "./pages/Brands/Brands";
import BrandCreate from "./pages/Brands/BrandCreate";
import Grocery from "./pages/Product/groceryProduct/grocery";
import ProductCreate from "./pages/Product/edit & create/ProductCreate";
import AdminProductDetails from "./pages/Product/edit & create/ProductDetaills";
import MainTicketPage from "./pages/tickets/MainTicketPage";
import TicketPage from "./pages/tickets/TicketPage";

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [accessToken, setAccessToken] = useState(
    localStorage.getItem("accessToken"),
  );

  useEffect(() => {
    if (!accessToken) {
      navigate("/");
    }
  }, []);

  return (
    <>
      <Toaster position="top-left" />
      {accessToken ? (
        <div className="grid grid-cols-10">
          <div className="col-span-2 md:hidden bg-secondColor-shade7 rounded-r-md min-h-screen h-full">
            <SideBar />
          </div>

          <div className="col-span-8 md:col-span-10">
            <Header />

            <Routes>
              <Route path={"/all-banner"} element={<AllBanners />} />
              <Route path={"/Multi-banner"} element={<MultiBanner />} />
              <Route path={"/Main-banner"} element={<MainBanner />} />
              <Route path={"/orderFood-banner"} element={<FoodBanner />} />
              <Route path={"/groceryStore-banner"} element={<MarketBanner />} />
              <Route
                path={"/all-banner/edit-Banners"}
                element={<EditBanners />}
              />
              <Route path={"/"} element={<Dashboard />} />
              <Route path={"/seller"} element={<Seller />} />
              <Route path={"/seller/:id"} element={<SellerDetails />} />
              <Route path={"/user"} element={<Users />} />
              <Route path={"/user/:id"} element={<UserDetails />} />

              <Route path={"/grocery-product"} element={<Grocery />} />
              <Route path={"/orders-product"} element={<Orders />} />
              <Route
                path={"/product/:type/:id"}
                element={<AdminProductDetails />}
              />
              <Route
                path={"/product/create/:type"}
                element={<ProductCreate />}
              />

              <Route path={"/category"} element={<Category />} />
              <Route path={"/brands"} element={<Brands />} />

              <Route path={"/brand/create"} element={<BrandCreate />} />
              <Route path={"/category/create"} element={<CategoryCreate />} />
              <Route path={"/comment"} element={<Comment />} />
              <Route path={"/invoice"} element={<Invoice />} />
              <Route
                path={"/invoice/details/:id"}
                element={<InvoiceDetails />}
              />
              <Route path={"/ticket"} element={<MainTicketPage />} />
              <Route path={"/ticket/:id"} element={<TicketPage />} />
              <Route path={"/payment-methode"} element={<PaymentMethod />} />
              <Route path={"/setting"} element={<MyProfile />} />
            </Routes>
          </div>
        </div>
      ) : (
        <Routes>
          <Route path={"/"} element={<Login />} />
        </Routes>
      )}
    </>
  );
}

export default App;
